export const GET_EVENTS = 'GET_EVENTS';
export const SEARCH_MEETINGS = 'SEARCH_MEETINGS';
export const GET_CURRENT_INQUIRY = 'GET_CURRENT_INQUIRY';
export const GET_EVENT = 'GET_EVENT';
export const GET_VENUE_INQUIRIES = 'GET_VENUE_INQUIRIES';
export const GET_TEAM_MEMBERS = 'GET_TEAM_MEMBERS';
export const VENUE_TOKEN = 'VENUE_TOKEN';
export const VENUE_CONTENT = 'VENUE_CONTENT';
export const GET_EVENT_RESOURCES = 'GET_EVENT_RESOURCES';
export const GET_BOOKINGS_FOR_EVENT = 'GET_BOOKINGS_FOR_EVENT';
export const VENUE_INSIGHTS_QUERY_KEY = 'venue-insights';
export const VENUE_REVIEWS_SUMMARY_QUERY_KEY = 'venue-reviews-summary';
export const GET_VENUE = 'GET_VENUE';
export const GET_EVENT_INQUIRY_PLANNER = 'GET_EVENT_PLANNER';
export const GET_PROPOSALS_FOR_INQUIRY = 'GET_PROPOSALS_FOR_INQUIRY';
export const ALL_VENUES = 'ALL_VENUES';
export const GET_VENUE_PROPOSAL = 'GET_VENUE_PROPOSAL';
export const GET_VENUE_PROPOSAL_ACCEPTED = 'GET_VENUE_PROPOSAL_ACCEPTED';
export const GET_PROPOSAL_CHANGES = 'GET_PROPOSAL_CHANGES';
export const GET_PROPOSAL_MESSAGES = 'GET_PROPOSAL_MESSAGES';
export const GET_PROPOSAL_MESSAGES_BY_VENUE = 'GET_PROPOSAL_MESSAGES_BY_VENUE';
export const GET_VENUE_REBID = 'GET_VENUE_REBID';
export const GET_DELEGATED_PROPOSAL_TOKENS = 'GET_DELEGATED_PROPOSAL_TOKENS';
export const GET_ATTENDEES = 'GET_ATTENDEES';
export const GET_PARCELS = 'GET_PARCELS';
export const GET_PARCEL = 'GET_PARCEL';
export const GET_QUESTIONS = 'GET_QUESTIONS';
export const GET_PLAYBOOK_PLANNER_DATA = 'GET_PLAYBOOK_PLANNER_DATA';
export const GET_RSVP_INFO = 'GET_RSVP_INFO';
export const GET_REGISTRATION_INFO = 'GET_REGISTRATION_INFO';
export const GET_EVENT_OPTIONS = 'GET_EVENT_OPTIONS';
export const VENUE_NAME_SUGGESTIONS = 'VENUE_NAME_SUGGESTIONS';
export const VENUE_GOOGLE_SUGGESTIONS = 'VENUE_GOOGLE_SUGGESTIONS';
export const GET_LEAD_VOLUME = 'GET_LEAD_VOLUME';
export const GET_LEAD_VOLUME_FILTERS = 'GET_LEAD_VOLUME_FILTERS';
